module.exports = __webpack_public_path__ + "static/media/20_A.20345d69.png";